import 'core-js/stable/array/at';
import 'core-js/stable/array/to-reversed';
import 'core-js/stable/array/to-sorted';
import 'core-js/stable/array/to-spliced';
import 'core-js/stable/array/with';
import 'core-js/stable/string/at';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { LicenseInfo } from '@mui/x-license';

import { registerChunkLoadRecovery } from 'helper/registerChunkLoadRecovery';

import App from './App';
import Sentry from './sentry';
import './index.css';

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_X_LICENSE_KEY || '');

registerChunkLoadRecovery();

const reportError = Sentry.reactErrorHandler((error, componentStack) => {
  console.error(error, componentStack);
});

createRoot(document.getElementById('root'), {
  onUncaughtError: reportError,
  onCaughtError: reportError,
  onRecoverableError: reportError,
}).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
